import { APISettings } from '../../config/ApiSettings';
import { DraftNote } from '../interfaces/DraftNote';
import { BaseAPI } from './baseApi';

const baseUrl = new APISettings().getApiURL();

class DraftNoteApi extends BaseAPI {
  public getByDraftId: (draftId: number) => Promise<any> = async (draftId: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/DraftNote/GetByDraftId/${draftId}`)).data.output;
  };

  public createDraftNote: (draftNote: DraftNote) => Promise<any> = async (draftNote: DraftNote) => {
    let encodedNoteHtml = btoa(unescape(encodeURIComponent(draftNote.note)));
    let encodedDraftNote = { ...draftNote, note: encodedNoteHtml };
    return (await BaseAPI.axios.post(`${baseUrl}/DraftNote`, encodedDraftNote)).data.output;
  };

  public updateDraftNote: (draftNote: DraftNote) => Promise<any> = async (draftNote: DraftNote) => {
    let encodedNoteHtml = btoa(unescape(encodeURIComponent(draftNote.note)));
    let encodedDraftNote = { ...draftNote, note: encodedNoteHtml };
    return (await BaseAPI.axios.put(`${baseUrl}/DraftNote`, encodedDraftNote)).data.output;
  };

  public delete: (id: number) => Promise<any> = async (id: number) => {
    return (await BaseAPI.axios.delete(`${baseUrl}/DraftNote/DeleteById/${id}`));
  };
}

export const draftNoteAPI = new DraftNoteApi();
